// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
*:not(dialog) {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

html,
body {
  margin: 0;
  background: #282a36;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family:
    ui-monospace, "Cascadia Code", "Source Code Pro", Menlo, Consolas,
    "DejaVu Sans Mono", monospace;
}

.container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  position: absolute;
  font-size: 10vw;
  font-weight: 900;
  text-transform: uppercase;
  color: #39ff14;
  text-shadow:
    0 0 10px #39ff14,
    0 0 20px #39ff14,
    0 0 40px #39ff14;
  opacity: 0.9;
}

.v1 {
  transform: translate(-2vw, -2vh) rotate(-2deg);
  opacity: 0.8;
}
.v2 {
  transform: translate(3vw, 1vh) rotate(3deg);
  opacity: 0.7;
}
.v3 {
  transform: translate(-1vw, 4vh) rotate(-4deg);
  opacity: 0.6;
}
.v4 {
  transform: translate(5vw, -3vh) rotate(5deg);
  opacity: 0.65;
}
.v5 {
  transform: translate(10vw, -7vh) rotate(1deg);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB;;iCAE+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd;;;oBAGkB;EAClB,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,UAAU;AACZ","sourcesContent":["/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n*:not(dialog) {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\nhtml,\nbody {\n  margin: 0;\n  background: #282a36;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  font-family:\n    ui-monospace, \"Cascadia Code\", \"Source Code Pro\", Menlo, Consolas,\n    \"DejaVu Sans Mono\", monospace;\n}\n\n.container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.text {\n  position: absolute;\n  font-size: 10vw;\n  font-weight: 900;\n  text-transform: uppercase;\n  color: #39ff14;\n  text-shadow:\n    0 0 10px #39ff14,\n    0 0 20px #39ff14,\n    0 0 40px #39ff14;\n  opacity: 0.9;\n}\n\n.v1 {\n  transform: translate(-2vw, -2vh) rotate(-2deg);\n  opacity: 0.8;\n}\n.v2 {\n  transform: translate(3vw, 1vh) rotate(3deg);\n  opacity: 0.7;\n}\n.v3 {\n  transform: translate(-1vw, 4vh) rotate(-4deg);\n  opacity: 0.6;\n}\n.v4 {\n  transform: translate(5vw, -3vh) rotate(5deg);\n  opacity: 0.65;\n}\n.v5 {\n  transform: translate(10vw, -7vh) rotate(1deg);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
